import { FC, useCallback, useRef } from 'react';

import { getElementAtEvent, Line } from 'react-chartjs-2';
import { ChartDataset, ChartOptions } from 'chart.js';

const getOptions = (name: string): ChartOptions<'line'> => {
  return {
    spanGaps: true,
    responsive: true,
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'day',
        },
        grid: {
          display: false,
        },
      },
      y: {
        min: 0,
        grid: {
          display: true,
        },
      },
    },
    plugins: {
      zoom: {
        zoom: {
          wheel: {
            enabled: true, // SET SCROOL ZOOM TO TRUE
          },
        },
        pan: {
          enabled: true,
        },
      },
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: name,
      },
    },
  };
};

const LineChart: FC<React.PropsWithChildren<LineChartProps>> = props => {
  const { data, labels, name, onClick } = props;
  const options = getOptions(name);
  const handleClick = useCallback(
    event => {
      if (chartRef.current) {
        const points = getElementAtEvent(chartRef.current, event);
        if (points[0]) {
          onClick && onClick(labels[points[0].index].scanId);
        }
      }
    },
    [labels, onClick],
  );
  const chartRef = useRef();

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <Line
        ref={chartRef}
        onClick={handleClick}
        options={options}
        data={{
          labels: labels.map(l => l.scanDate),
          datasets: data,
        }}
      />
    </div>
  );
};

export interface LineChartProps {
  data: ChartDataset<'line', number[]>[];
  labels: { scanId: string; scanDate: string }[];
  name: string;
  time?: boolean;
  onClick?: (scanId: string) => void;
}

export default LineChart;
